import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ContactUsDialogService } from '../../contact-us-dialog.service';

@Component({
    selector: 'in2-get-in-touch',
    imports: [],
    templateUrl: './get-in-touch.component.html',
    styleUrls: ['./get-in-touch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GetInTouchComponent {
 readonly contactUsDialogService = inject(ContactUsDialogService)
}
